import ReportDetailsHeader from 'Components/ReportDetailsHeader';
import React from 'react';
import { Card, CardHeader, Col, Row, TabContent, TabPane } from 'reactstrap';
import { EventPrecedence, OperationPrecedence } from 'shared/constants';
import SludgeBilgeWaterComponent from './partials/SludgeBilgeWaterComponent';
import EngineParameterComponent from './partials/EngineParameterComponent';
import ThermalOilHeaterComponent from './partials/ThermalOilHeaterComponent';
import { useDocumentTitle } from 'Components/useDocument.hooks';
import { RootState } from 'index';
import { useSelector } from 'react-redux';
import { checkValidObject } from 'GenericForms/Helper';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';

interface LfondsAddInformationType {
    tabsIdList: any[],
    toggleDynamicTabs: any
    setErrorMessage: (value: boolean) => void,
    toggleAddLfondsTab: (value: number) => void,
    editReportBool: boolean,
    setPreviousTabIndex: any
}

const LfondsAddInformation = ({
    toggleDynamicTabs,
    setErrorMessage,
    toggleAddLfondsTab,
    editReportBool,
    setPreviousTabIndex
}: LfondsAddInformationType) => {
    const { activeAddLfondsTab } = useEditReport();
    /** State variables start*/
    useDocumentTitle('Lfonds Additional Information - ecoSAIL');
    const { CurrentReport } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    /** State variables end*/

    /** Functions to determine tab ids based on visibility */
    const sludgeBilgeWaterDetailsTabId = () => {
        if (checkValidObject(currentVesselReport)) {
            if (
                currentVesselReport?.event_precedence_id === EventPrecedence.NOON ||
                currentVesselReport?.only_noon_or_combine_with_other_event === "combine_with_other_report"
            ) {
                return 1;
            }
            return 0;
        }
    }

    const EngineParameterTabId = () => {
        if (checkValidObject(currentVesselReport)) {
            if (
                (currentVesselReport?.event_precedence_id === EventPrecedence.NOON ||
                    currentVesselReport?.only_noon_or_combine_with_other_event === "combine_with_other_report") &&
                currentVesselReport.operation_precedence_id === OperationPrecedence.SEA_PASSAGE
            ) {
                return 2;
            } else if (
                (currentVesselReport?.event_precedence_id !== EventPrecedence.NOON ||
                    currentVesselReport?.only_noon_or_combine_with_other_event !== "combine_with_other_report") &&
                currentVesselReport.operation_precedence_id === OperationPrecedence.SEA_PASSAGE
            ) {
                return 1;
            }
            return 0;
        }
    }

    const ThermalOilHeaterTabId = () => {
        if (checkValidObject(currentVesselReport)) {
            if (
                (currentVesselReport?.event_precedence_id === EventPrecedence.NOON ||
                    currentVesselReport?.only_noon_or_combine_with_other_event === "combine_with_other_report") &&
                currentVesselReport.operation_precedence_id === OperationPrecedence.SEA_PASSAGE
            ) {
                return 3;
            } else if (
                ((currentVesselReport?.event_precedence_id !== EventPrecedence.NOON ||
                    currentVesselReport?.only_noon_or_combine_with_other_event !== "combine_with_other_report") &&
                    currentVesselReport.operation_precedence_id === OperationPrecedence.SEA_PASSAGE) ||
                ((currentVesselReport?.event_precedence_id === EventPrecedence.NOON ||
                    currentVesselReport?.only_noon_or_combine_with_other_event === "combine_with_other_report") &&
                    currentVesselReport.operation_precedence_id !== OperationPrecedence.SEA_PASSAGE)
            ) {
                return 2;
            } else {
                return 1
            }
        }
        return 0;
    }
    /** Tab id functions end */

    return (
        <Card className='p-0 mb-0 border-0'>
            <CardHeader className='p-2'>
                <div className="text-center">
                    <Row>
                        <Col>
                            <h4 className="page_title pos-start mb-0">Additional Information</h4>
                            <p className="card-title-desc pos-start">All readings since last report</p>
                        </Col>
                        <Col>
                            <ReportDetailsHeader />
                        </Col>
                    </Row>
                </div>
            </CardHeader>
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
                <TabContent activeTab={activeAddLfondsTab} className="tabHeight">
                    <TabPane tabId={sludgeBilgeWaterDetailsTabId()}>
                        <SludgeBilgeWaterComponent
                            toggleAddTab={toggleAddLfondsTab}
                            toggleDynamicTabs={toggleDynamicTabs}
                            setErrorMessage={setErrorMessage}
                            editReportBool={editReportBool}
                            activeAddTab={activeAddLfondsTab}
                        />
                    </TabPane>
                    <TabPane tabId={EngineParameterTabId()}>
                        <EngineParameterComponent
                            toggleAddTab={toggleAddLfondsTab}
                            activeAddTab={activeAddLfondsTab}
                            toggleDynamicTabs={toggleDynamicTabs}
                            setErrorMessage={setErrorMessage}
                            editReportBool={editReportBool}
                        />
                    </TabPane>
                    <TabPane tabId={ThermalOilHeaterTabId()}>
                        <ThermalOilHeaterComponent
                            toggleAddTab={toggleAddLfondsTab}
                            toggleDynamicTabs={toggleDynamicTabs}
                            setErrorMessage={setErrorMessage}
                            editReportBool={editReportBool}
                            setPreviousTabIndex={setPreviousTabIndex}
                            activeAddTab={activeAddLfondsTab}
                        />
                    </TabPane>
                </TabContent>
            </div>
        </Card>
    )
}

export default LfondsAddInformation